import { GlobalReducer } from '../app';
import { Reducer } from 'redux';
import { initialResponseState, IResponseState } from '../state';
import { IUpdateHospitalAction } from './updateHospital.interface';
import { UpdateHospitalAction, UpdateHospitalTypes } from './updateHospital.type';

export const UpdateHospitalReducer: Reducer<IResponseState, IUpdateHospitalAction> = (
	state = initialResponseState,
	action: UpdateHospitalAction,
) => GlobalReducer(state, action, UpdateHospitalTypes.UPDATE_HOSPITAL.toString());
